<template>
  <main class="mod">
    <div class="container">
<!-- Header card (replaces .page-head + .card--toolbar) -->
<!-- Header card (single, centered, stacked) -->
<section class="card card--head">
  <div class="head">
    <div class="head__titles">
      <h1>Moderation Panel</h1>
      <p class="sub">Manage users, invites, and permissions.</p>
    </div>

   <div class="quicklinks">
  <router-link
    to="/modsecuritypanel"
    class="ql"
    data-tip="Security Dashboard – manage security events and risks"
    aria-label="Security Dashboard – manage security events and risks"
  >Dashboard</router-link>

  <router-link
    to="/requestmonitor"
    class="ql"
    data-tip="Request Monitor – view and filter analysis requests"
    aria-label="Request Monitor – view and filter analysis requests"
  >Request Monitor</router-link>

  <router-link
    to="/signupreview"
    class="ql"
    data-tip="Signup Review – approve or reject new user signups"
    aria-label="Signup Review – approve or reject new user signups"
  >Signup Review</router-link>

  <router-link
    to="/securitytools"
    class="ql"
    data-tip="Tools – access moderation and security utilities"
    aria-label="Tools – access moderation and security utilities"
  >Tools</router-link>

  <router-link
    to="/supporttickets"
    class="ql"
    data-tip="Support Tickets – respond to and manage user tickets"
    aria-label="Support Tickets – respond to and manage user tickets"
  >Support Tickets</router-link>

  
  <router-link
    to="/useraccounts"
    class="ql"
    data-tip="Manage Users – manage users"
    aria-label="Manage Users – manage users"
  >Manage Users</router-link>

  <router-link
    to="/AdminSignupsDashboard"
    class="ql"
    data-tip="Site metrics"
    aria-label="Site metrics"
  >Metric Dashboard</router-link>

  <router-link
    to="/linkchecktool"
    class="ql"
    data-tip="LinkCheck - tool that is in testing"
    aria-label="LinkCheck - tool that is in testing"
  >LinkCheck</router-link>

  <router-link
    to="/PromoCodeManagerNew"
    class="ql"
    data-tip="Promo Codes – manage promo codes"
    aria-label="Promo Codes – manage promo codes"
  >Promo Codes</router-link>

</div>
  </div>
</section>

      <!-- Status banner -->
      <transition name="fade">
        <p v-if="statusMessage" :class="['status', statusType]">{{ statusMessage }}</p>
      </transition>

      <!-- Actions grid -->
      <section class="grid">
        <!-- Create User -->
        <article class="card">
          <h2 class="card__title">Create user</h2>
          <form class="form" @submit.prevent="createUser">
            <div class="field">
              <label>Username</label>
              <input v-model.trim="username" type="text" data-1p-ignore required maxlength="50" placeholder="e.g. alice_k" />
            </div>
            <div class="field">
              <label>Password</label>
              <input v-model="password" type="password"  required maxlength="50" placeholder="Set temporary password" />
            </div>
            <button class="btn btn--primary" type="submit">Create user</button>
          </form>
        </article>

        <!-- Invite with Username -->
        <article class="card">
          <h2 class="card__title">Invite by email (assign username)</h2>
          <form class="form" @submit.prevent="sendInvite">
            <div class="field">
              <label>Username</label>
              <input v-model.trim="inviteUsername" type="text" required data-1p-ignore maxlength="50" placeholder="Choose username" />
            </div>
            <div class="field">
              <label>Email</label>
              <input v-model.trim="email" type="email" required data-1p-ignore maxlength="100" placeholder="user@domain.com" />
            </div>
            <button class="btn" type="submit">Send invite</button>
          </form>
        </article>

        <!-- Simple Invite -->
        <article class="card">
          <h2 class="card__title">Invite by email (simple)</h2>
          <form class="form" @submit.prevent="sendSimpleInvite">
            <div class="field">
              <label>Email</label>
              <input v-model.trim="simpleInviteEmail" type="email" data-1p-ignore required maxlength="100" placeholder="user@domain.com" />
            </div>
            <button class="btn" type="submit">Send invite</button>
          </form>
        </article>
      </section>
<!-- Pending Invites -->
<section class="card">
  <div class="card__header">
    <h2>Pending invites</h2>
  </div>

  <div v-if="!pendingInvites?.length" class="empty">
    No pending invites.
  </div>

  <div v-else class="table-wrap">
    <table class="table">
      <thead>
        <tr>
          <th>Username</th>
          <th>Email</th>
          <th>Referral</th>
          <th>Promo</th>
          <th>Expires</th>
          <th class="th-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="invite in pendingInvites" :key="invite.id">
          <td>{{ invite.username || '—' }}</td>
          <td>{{ invite.email }}</td>
          <td>
            <span v-if="invite.referral_code" class="badge">{{ invite.referral_code }}</span>
            <span v-else>—</span>
          </td>
          <td>
            <span v-if="invite.promo_code" class="badge badge--promo">{{ invite.promo_code }}</span>
            <span v-else>—</span>
          </td>
          <td>{{ invite.expires_at }}</td>
          <td class="actions">
            <button class="btn btn--ghost" @click="resendInvite(invite)">Resend</button>
            <button class="btn btn--ghost" @click="editInviteCodes(invite)">Edit Codes</button>
            <button class="btn btn--danger" @click="revokeInvite(invite.id)">Revoke</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
    <!-- Users -->
<section class="card">
  <div class="card__header">
    <h2>Existing users</h2>

    <!-- Pagination controls (top) -->
    <div class="pager">
      <label class="pager__size">
        Rows:
        <select v-model.number="pageSize">
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </label>
      <div class="pager__nav">
        <button class="btn btn--ghost" :disabled="currentPage===1" @click="gotoPage(1)">«</button>
        <button class="btn btn--ghost" :disabled="currentPage===1" @click="prevPage()">‹</button>
        <span class="pager__label">{{ currentPage }} / {{ totalPages }}</span>
        <button class="btn btn--ghost" :disabled="currentPage===totalPages" @click="nextPage()">›</button>
        <button class="btn btn--ghost" :disabled="currentPage===totalPages" @click="gotoPage(totalPages)">»</button>
      </div>
    </div>
  </div>

<div v-if="isLoadingUsers" class="empty">Loading users…</div>
<div v-else-if="totalUsers === 0" class="empty">No users found.</div>

  <div v-else class="table-wrap">
    <table class="table">
      <thead>
        <tr>
          <th>Username</th>
          <th>Role</th>
          <th>Advanced mode</th>
          <th class="th-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in paginatedUsers" :key="user.id">
          <td class="mono">{{ user.username }}</td>
          <td><span class="pill" :class="'role-' + (user.role || 'user')">{{ user.role }}</span></td>
          <td>
            <span class="pill" :class="user.can_use_normal_mode ? 'ok' : 'muted'">
              {{ user.can_use_normal_mode ? 'Enabled' : 'Disabled' }}
            </span>
          </td>
          <td class="actions">
    <button
  v-if="user.role !== 'admin'"
  class="btn"
  :class="user.can_use_normal_mode ? 'btn--danger-outline' : 'btn--success'"
  @click="toggleNormalMode(user.id)"
>
  {{ user.can_use_normal_mode ? 'Disable' : 'Enable' }} advanced mode
</button>

          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination controls (bottom, compact) -->
  <div v-if="users?.length" class="pager pager--bottom">
    <div class="pager__nav">
      <button class="btn btn--ghost" :disabled="currentPage===1" @click="prevPage()">‹ Prev</button>
      <span class="pager__label">{{ currentPage }} / {{ totalPages }}</span>
      <button class="btn btn--ghost" :disabled="currentPage===totalPages" @click="nextPage()">Next ›</button>
    </div>
  </div>
</section>
    </div>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ModeratorPage',
  data() {
    return {
      username: '',
      password: '',
      users: [],
      totalUsers: 0,          // NEW: total rows across all pages
      isLoadingUsers: false,  // optional but handy

      statusMessage: '',
      statusType: '', // 'success' | 'error'

      inviteUsername: '',
      email: '',
      simpleInviteEmail: '',
      pendingInvites: [],

      // pagination
      pageSize: 25,
      currentPage: 1
    };
  },

  created() {
    this.fetchUsers(1);
    this.fetchInvites();
  },

  mounted() {
    document.body.classList.add('route-mod');
  },

  beforeUnmount() {
    document.body.classList.remove('route-mod');
  },

  computed: {
    totalPages() {
      // Use server-reported total, not the length of the current page
      return Math.max(1, Math.ceil(this.totalUsers / this.pageSize));
    },

    paginatedUsers() {
      // Server already paginates; this.users IS the current page
      return this.users;
    }
  },

  watch: {
    // When page size changes, go back to page 1 and refetch from server
    pageSize() {
      this.fetchUsers(1);
    }
  },

  methods: {
    gotoPage(n) {
      const target = Math.min(Math.max(1, n), this.totalPages);
      this.fetchUsers(target);
    },
    nextPage() {
      this.gotoPage(this.currentPage + 1);
    },
    prevPage() {
      this.gotoPage(this.currentPage - 1);
    },

    isValidUsername(name) {
      return /^[a-zA-Z][a-zA-Z0-9_]{2,49}$/.test(name);
    },

    showStatus(msg, type = 'success') {
      this.statusMessage = msg;
      this.statusType = type;
      clearTimeout(this._statusTimer);
      this._statusTimer = setTimeout(() => (this.statusMessage = ''), 3500);
    },

    // === API calls ===
    createUser() {
      if (!this.isValidUsername(this.username)) {
        return this.showStatus(
          'Invalid username. Must start with a letter and use only letters, numbers, or underscores.',
          'error'
        );
      }

      axios.post(
        'etherscan/create_user.php',
        { username: this.username, password: this.password },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      ).then(({ data }) => {
        if (data.status === 'success') {
          // keep user on same page after creation (or choose fetchUsers(1) if you prefer)
          this.fetchUsers(this.currentPage);

          this.username = '';
          this.password = '';
          this.showStatus('User created successfully.', 'success');
        } else {
          this.showStatus('Failed to create user: ' + data.message, 'error');
        }
      }).catch(() => this.showStatus('An error occurred while creating the user.', 'error'));
    },

    sendInvite() {
      if (!this.isValidUsername(this.inviteUsername)) {
        return this.showStatus(
          'Invalid username. Must start with a letter and use only letters, numbers, or underscores.',
          'error'
        );
      }

      axios.post(
        'etherscan/send_invite.php',
        { username: this.inviteUsername, email: this.email },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      ).then(({ data }) => {
        if (data.status === 'success') {
          this.inviteUsername = '';
          this.email = '';
          this.fetchInvites();
          this.showStatus('Invite sent successfully.', 'success');
        } else {
          this.showStatus('Failed to send invite: ' + data.message, 'error');
        }
      }).catch(() => this.showStatus('An error occurred while sending the invite.', 'error'));
    },

    sendSimpleInvite() {
      axios.post(
        'etherscan/send_simple_invite.php',
        { email: this.simpleInviteEmail },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      ).then(({ data }) => {
        if (data.status === 'success') {
          this.simpleInviteEmail = '';
          this.fetchInvites?.();
          this.showStatus('Simple invite sent successfully.', 'success');
        } else {
          this.showStatus('Failed to send invite: ' + data.message, 'error');
        }
      }).catch(() => this.showStatus('An error occurred while sending the invite.', 'error'));
    },

    fetchInvites() {
      axios.get('etherscan/get_pending_invites.php', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }).then(({ data }) => {
        if (data.status === 'success') this.pendingInvites = data.invites;
      }).catch(() => {
        // optional status UI
      });
    },

    async editInviteCodes(invite) {
      const newRef = window.prompt('Set referral code (leave empty to clear):', invite.referral_code || '');
      if (newRef === null) return;
      const newPromo = window.prompt('Set promo code (leave empty to clear):', invite.promo_code || '');
      if (newPromo === null) return;

      try {
        const payload = {
          invite_id: invite.id,
          referral_code: newRef.trim(),
          promo_code: newPromo.trim()
        };

        const { data } = await axios.post('etherscan/update_invite_codes.php', payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });

        if (data.status === 'success') {
          this.fetchInvites();
          this.statusMessage = 'Invite codes updated.';
          this.statusType = 'success';
        } else {
          this.statusMessage = data.message || 'Failed to update invite.';
          this.statusType = 'error';
        }
      } catch (e) {
        this.statusMessage = 'Failed to update invite.';
        this.statusType = 'error';
      } finally {
        setTimeout(() => { this.statusMessage = ''; this.statusType=''; }, 3000);
      }
    },

    resendInvite(invite) {
      axios.post(
        'etherscan/send_invite.php',
        { username: invite.username, email: invite.email },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      ).then(({ data }) => {
        this.showStatus(data.status === 'success' ? 'Invite resent.' : data.message, 'success');
      });
    },

    revokeInvite(id) {
      axios.post(
        'etherscan/revoke_invite.php',
        { id },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      ).then(({ data }) => {
        this.showStatus(data.status === 'success' ? 'Invite revoked.' : data.message, 'success');
        this.fetchInvites();
      });
    },

    toggleNormalMode(userId) {
      axios.post(
        'etherscan/toggle_normal_mode.php',
        { id: userId },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      ).then(({ data }) => {
        if (data.status === 'success') {
          // IMPORTANT: refetch the current page from server
          this.fetchUsers(this.currentPage);
          this.showStatus('Advanced mode permission updated.', 'success');
        } else {
          this.showStatus('Failed to update permission: ' + data.message, 'error');
        }
      }).catch(() => this.showStatus('An error occurred while updating permission.', 'error'));
    },

    fetchUsers(page = this.currentPage) {
      this.isLoadingUsers = true;

      axios.get('etherscan/get_users.php', {
        params: {
          page,
          limit: this.pageSize
        },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }).then(({ data }) => {
        if (data.status === 'success') {
          this.users = Array.isArray(data.users) ? data.users : [];
          this.totalUsers = Number.isFinite(+data.total) ? +data.total : this.users.length;

          // Keep client in sync with server sanitization
          this.currentPage = Number.isFinite(+data.page) ? +data.page : page;
          this.pageSize = Number.isFinite(+data.limit) ? +data.limit : this.pageSize;

          // If we somehow landed out of range (e.g., total shrank), pull last valid page
          const lastPage = Math.max(1, Math.ceil(this.totalUsers / this.pageSize));
          if (this.currentPage > lastPage) {
            this.fetchUsers(lastPage);
          }
        } else {
          this.showStatus('Failed to fetch users: ' + (data.message || ''), 'error');
        }
      }).catch(() => {
        this.showStatus('An error occurred while fetching users.', 'error');
      }).finally(() => {
        this.isLoadingUsers = false;
      });
    }
  }
};
</script>


<style scoped>
/* Light, clean admin look aligned with your other pages */
.mod {
  --bg: #f7f9fc;
  --card: #ffffff;
  --ink: #1f2a37;
  --muted: #6b7280;
  --border: #e5e8ec;
  --accent: #35495e;
  --accent-2: #2c80b4;

  color: var(--ink);
  padding: 1.25rem 1rem 2.5rem;
  background: var(--bg);
}
.container { max-width: 1120px; margin: 0 auto; }

.page-head h1 { margin: 0; font-size: clamp(1.4rem, 1.2rem + 1vw, 1.9rem); }
.page-head .sub { margin: .25rem 0 0; color: var(--muted); }

/* Status banner */
.status {
  margin: .75rem 0;
  padding: .7rem .9rem;
  border-radius: 10px;
  border: 1px solid var(--border);
  font-weight: 600;
}
.status.success { background: #ebf7ef; color: #1f6b3a; border-color: #d5ecdc; }
.status.error   { background: #fdeaea; color: #8f1d1d; border-color: #f4c7c7; }

.fade-enter-active,.fade-leave-active { transition: opacity .18s ease; }
.fade-enter-from,.fade-leave-to { opacity: 0; }

/* Cards & grid */
.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
.card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: 0 10px 20px rgba(16,24,40,.06);
  padding: 1rem;
  overflow: hidden; 
}
.card__title { margin: 0 0 .45rem; font-size: 1.05rem; }
.card__header { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: .5rem; }


/* Fix inputs extending past card edges */
.mod * { box-sizing: border-box; }

.grid { align-items: start; }              /* prevent equal-height stretching causing odd widths */

.form, .field { min-width: 0; }            /* allow children to shrink within grid columns */

input, select, textarea {
  width: 100%;
  max-width: 100%;
  min-width: 0;                            /* Safari/Firefox: prevent overflow in grid/flex */
  box-sizing: border-box;                  /* belt & suspenders */
}

/* Forms */
.form { display: grid; gap: .6rem; }
.field { display: grid; gap: .35rem; text-align: left; }
label { color: var(--muted); font-size: .92rem; }
input {
  width: 100%;
  padding: .7rem .8rem;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--ink);
}
input:focus { outline: none; box-shadow: 0 0 0 3px rgba(44,128,180,.18); border-color: #cfe0ec; }

/* Buttons */
.btn {
  display: inline-flex; align-items: center; justify-content: center;
  padding: .7rem .95rem; border-radius: 10px; font-weight: 700; cursor: pointer;
  border: 1px solid var(--border); background: #fff; color: var(--accent);
  transition: filter 140ms ease, box-shadow 140ms ease;
}
.btn:hover { filter: brightness(.98); }
.btn--primary { border-color: transparent; background: linear-gradient(180deg, var(--accent-2), #1f6d9a); color: #fff; box-shadow: 0 6px 14px rgba(31,109,154,.18); }
.btn--ghost { background: #fff; color: var(--accent); }
.btn--danger { background: #fff5f5; color: #8f1d1d; border-color: #f4c7c7; }
.btn--danger:hover { filter: none; }

/* Tables */
.table-wrap { overflow: auto; border: 1px solid var(--border); border-radius: 12px; }
.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 680px;
}
.table th, .table td {
  text-align: left;
  padding: .7rem .8rem;
  border-bottom: 1px solid var(--border);
  background: #fff;
}
.table thead th { font-size: .9rem; color: var(--muted); background: #f9fbfe; }
.table tbody tr:last-child td { border-bottom: none; }
.th-actions, .actions { text-align: right; white-space: nowrap; }
.actions .btn { margin-left: .4rem; }
.mono { font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace; }

/* Pills */
.pill {
  display: inline-block;
  padding: .2rem .5rem;
  border-radius: 999px;
  font-size: .8rem;
  font-weight: 700;
  border: 1px solid var(--border);
  background: #f3f6fb;
  color: #374151;
}
.pill.ok { background: #e9f7ef; color: #1f6b3a; border-color: #cfe9d8; }
.pill.muted { background: #f1f5f9; color: #475569; }
.pill.role-admin { background: #fff0f0; color: #8f1d1d; border-color: #f4c7c7; }

/* Empty */
.empty {
  padding: .9rem 1rem;
  color: var(--muted);
  background: #f8fafc;
  border: 1px dashed var(--border);
  border-radius: 12px;
  text-align: center;
}

/* Quick links */
.quicklinks {
  margin-top: 1rem;
  display: flex; flex-wrap: wrap; gap: .5rem;
}
.ql {
  padding: .45rem .7rem; border: 1px solid var(--border); border-radius: 10px; text-decoration: none;
  color: #0b63a9; background: #fff;
}
.ql:hover { text-decoration: underline; }

/* Responsive */
@media (max-width: 960px) { .grid { grid-template-columns: 1fr; } }


/* Pager */
.pager {
  display: flex;
  gap: .75rem;
  align-items: center;
  flex-wrap: wrap;
}
.pager__size {
  display: inline-flex; align-items: center; gap: .4rem;
  color: var(--muted); font-size: .9rem;
}
.pager__size select {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: .35rem .5rem;
  background: #fff;
  color: var(--ink);
}
.pager__nav { display: inline-flex; align-items: center; gap: .35rem; }
.pager__label { min-width: 4ch; text-align: center; color: var(--muted); }
.pager--bottom { margin-top: .6rem; justify-content: flex-end; }

/* Optional: sticky table header for long lists */
.table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}

/* Ensure the table wrapper can scroll if tall */
.table-wrap { max-height: 60vh; overflow: auto; }

/* Header card layout: vertical, centered */
.card--head { margin-top: .25rem; }
.card--head .head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .75rem;
  text-align: center;
}
.head__titles h1 { margin: 0; font-size: clamp(1.4rem, 1.2rem + 1vw, 1.9rem); }
.head__titles .sub { margin: .25rem 0 0; color: var(--muted); }

/* Quick links centered */
.card--head .quicklinks { display: flex; flex-wrap: wrap; gap: .5rem; justify-content: center; }
.card--head .ql {
  padding: .45rem .7rem; border: 1px solid var(--border); border-radius: 10px;
  text-decoration: none; color: #0b63a9; background: #fff;
}
.card--head .ql:hover { text-decoration: underline; }

/* Stack on small screens */
@media (max-width: 720px) {
  .card--head .head { grid-template-columns: 1fr; }
  .card--head .quicklinks { justify-content: flex-start; }
}

/* Distinct action buttons */
.btn--success {
  border-color: transparent;
  background: linear-gradient(180deg, #22c55e, #16a34a);
  color: #fff;
  box-shadow: 0 6px 14px rgba(22,163,74,.18);
}
.btn--success:hover { filter: brightness(1.05); }

.btn--danger-outline {
  background: #fff;
  color: #8f1d1d;
  border: 1px solid #f4c7c7;
}
.btn--danger-outline:hover { background: #fff5f5; }


/* Let only the header card overflow so tooltips can escape */
.card--head { overflow: visible; }

/* Tooltip styles (above, centered) */
.ql { position: relative; }
.ql:hover::after,
.ql:focus-visible::after {
  content: attr(data-tip);
  position: absolute;
  left: 50%;
  bottom: calc(100% + 10px);   /* ABOVE the button */
  transform: translateX(-50%);
  background: #1f2a37;
  color: #fff;
  padding: .35rem .6rem;
  border-radius: 6px;
  white-space: nowrap;
  font-size: .8rem;
  line-height: 1;
  z-index: 5;                  /* sit over the card */
  pointer-events: none;
  box-shadow: 0 6px 14px rgba(16,24,40,.18);
}

/* Little arrow pointing down to the button */
.ql:hover::before,
.ql:focus-visible::before {
  content: "";
  position: absolute;
  left: 50%;
  bottom: calc(100% + 4px);
  transform: translateX(-50%);
  width: 8px; height: 8px;
  background: #1f2a37;
  transform: translateX(-50%) rotate(45deg);
  z-index: 4;
}

/* Optional: keep tooltips readable near edges on small screens */
@media (max-width: 480px) {
  .ql:hover::after,
  .ql:focus-visible::after {
    max-width: 80vw;
    white-space: normal;       /* allow wrap on tiny screens */
    text-align: center;
  }
}
.badge { display:inline-block; padding:2px 6px; border-radius:4px; font-size:12px; border:1px solid #ccc; }
.badge--promo { background:#e6f7ff; border-color:#91d5ff; color:#096dd9; }

</style>

<!-- Route-scoped background & navbar layering (no App.vue edits) -->
<style>
.route-mod #app > nav { z-index: 1000; }
.route-mod,
.route-mod #app,
.route-mod #app > main { background: #f7f9fc; }
</style>